import { useState, useEffect } from 'react';

// Hook to detect container size instead of viewport size
export const useContainerSize = (containerRef) => {
  const [containerSize, setContainerSize] = useState('medium');
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateContainerSize = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const { width, height } = rect;
        
        setDimensions({ width, height });
        
        // Determine size based on container dimensions, not viewport
        if (width < 300 || height < 400) {
          setContainerSize('small');
        } else if (width < 500 || height < 600) {
          setContainerSize('medium');
        } else if (width < 800 || height < 800) {
          setContainerSize('large');
        } else {
          setContainerSize('xlarge');
        }
      }
    };

    // Use ResizeObserver for better performance than window resize
    const resizeObserver = new ResizeObserver(updateContainerSize);
    
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
      updateContainerSize(); // Initial measurement
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [containerRef]);

  return { containerSize, dimensions };
};
